import _ from "lodash";

export function orderByReceivedAt(data) {
  return _.orderBy(data, "receivedAt", "desc");
}
